import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mapboxTokenIndex:false,
    //地球上标记的字体
    // font:["Alibaba PuHuiTi Regular"],
    font:["Arial Unicode MS Regular","DIN Pro Regular"],


    nickName:'',
    avatar:'',
    userId:'',
    email:'',
    introduce:'',
    appBound:false,
    showFeedBackDialog:false,
    //弹窗信息
    editCreationInfo:{},
    deleteCreationId:"",
    //图形验证码
    picCaptcha:"",
    picCaptchaError:false,
    //主页
    homeLeftBarSelectedIndex:0,   //主页侧边栏选中项，设999为通知公告
    newNotice:false,    //有新通知公告状态
    showDownloadProductsDialog:false,
    threeDIndex:-1,
    //地球预览状态
    imagePreviewShow:false,
    //地图操作页面
    globeOperationMarkerList:[],   //标记列表
    deleteNode:'',//要被删除的Node数组
    selectNode:'',//被选中的Node
    hideControlNode:'',//控制显隐的node
    handleNodeOption:'',//当前的操作
    addId:'',//添加的ID
    //地球操作-录屏
    globeOperationScene:false,   //仅用于退出页面弹窗，判断当前是否在录屏
    //地球录屏-全屏播放
    globeSceneFullScreen:false,
    //退出影像中心时是否提示退出弹窗
    globeQuitShowDialog:false,

    //地球操作页面，切换侧边栏时保留数据
    currGlobeMainArea:"globeOperation",    //地球页面 当前选中的侧边栏
    initGlobeOperationMarker:false,    //初始进入地球操作栏时没有加载标记，之后左侧栏切换不需要再次加载
    //当前文件
    currFolderId:"",   //当前打开的文件id
    currFolderName:"",
    currFolderPublicStatus:"",
    currFolderType:0,//当前文件类型 0 个人文件  1团队文件
    currFolderTeamExport:1,//团队文件是否导出  1 可 0 不可
    currFolderTeamInvite:1,//团队文件可邀请成员  1 可 0 不可
    currFolderTeamReadonly:0,//团队文件制度  1 只读 0 可新增
    currFolderTeamSave:1, //团队文件是否可以保存  1可 0 不可
    currFolderMembersNumber:0,//

    currFolderMember:[],//当前团队人员
    globeOperationLayerList:[],//图层列表
      currFolderRole:1, // 1创建者  2,管理者 ，3编辑者
      selectLayerTreeNode:'',//图层列表被选中的Node
    //当前文件类型
    //当前文件命名计数
    folderIndex:0,
    markerIndex:0,
    lineIndex:0,
    roadIndex:0,
    polygonIndex:0,
    administrativeAreaIndex:0,

    //样例数据
    exampleShow:true,
    exampleList:[],

    //地球录制 当前文件
    currSceneFolderId:"",   //当前打开的文件id
    //地球录制 类型
    sceneType:"自定义动画",
    //地球录制 场景列表
    sceneList:[],

    sceneItemDragging:false,   //录制点排序
    tempSceneList:[],    //排序时的临时场景列表
    sceneItemMultipleChoosing:false,   //录制点多选
    sceneItemMultipleChoosingList:[],

    // scenePointNameIndex:0,
    currChooseSceneItemId:"",   //当前选中的录制点
    currChooseSceneItemIndex:"",
    currChooseViewItemId:"",   //当前选中的视野点
    currChooseViewItemIndex:"",
    currChooseMaterialItemId:"",   //当前选中的素材
    currChooseMaterialItem:"",
    currChooseMaterialItemIndex:"",

    //录制 右上角视野点弹窗显隐
    sceneViewPointAreaShow:false,
    tempViewPointList:[],   //临时视野点列表，不选中任何录制点时使用（如新建录制点过程中）
    tempSceneZoomBasis:"",

    //素材
    defaultMaterialMarkerData:{
        pointList:[],
        lineList:{    //素材-线
            //线
            line:{
                'type': 'FeatureCollection',
                'features': []
            },
            //线名
            lineName:{
                'type': 'FeatureCollection',
                'features': []
            },
            //线拐点
            linePoint:{
                'type': 'FeatureCollection',
                'features': []
            },

        },
        polygonList:{
            //多边形
            polygon:{
                'type': 'FeatureCollection',
                'features': []
            },
            //多边形名
            polygonName:{
                'type': 'FeatureCollection',
                'features': []
            },
            //多边形拐点
            polygonPoint:{
                'type': 'FeatureCollection',
                'features': []
            },

        },
        imageList:[],

    },   //默认地图素材marker数据
    //临时素材列表，不选中任何录制点时使用（如新建录制点过程中）
    tempMaterialInfo:{   //临时素材列表，不选中任何录制点时使用（如新建录制点过程中）
      materialList:[],
      materialMarkerData:{
          pointList:[],
          lineList:{    //素材-线
              //线
              line:{
                  'type': 'FeatureCollection',
                  'features': []
              },
              //线名
              lineName:{
                  'type': 'FeatureCollection',
                  'features': []
              },
              //线拐点
              linePoint:{
                  'type': 'FeatureCollection',
                  'features': []
              },

          },
          polygonList:{
              //多边形
              polygon:{
                  'type': 'FeatureCollection',
                  'features': []
              },
              //多边形名
              polygonName:{
                  'type': 'FeatureCollection',
                  'features': []
              },
              //多边形拐点
              polygonPoint:{
                  'type': 'FeatureCollection',
                  'features': []
              },

          },
          imageList:[],

      }
    },
    //当前选中素材底图数据，放在最顶层
    currChooseMaterialMarkerData:{
      lineList:{    //素材-线
        //线
        line:{
          'type': 'FeatureCollection',
          'features': []
        },
        //线名
        lineName:{
          'type': 'FeatureCollection',
          'features': []
        },
        //线拐点
        linePoint:{
          'type': 'FeatureCollection',
          'features': []
        },

      },
      polygonList:{
        //多边形
        polygon:{
          'type': 'FeatureCollection',
          'features': []
        },
        //多边形名
        polygonName:{
          'type': 'FeatureCollection',
          'features': []
        },
        //多边形拐点
        polygonPoint:{
          'type': 'FeatureCollection',
          'features': []
        },

      }
    },
    //设置素材显示样式弹窗
    setMaterialAreaShow:false,

    //播放时的常显素材
    sceneMaterialShow_allShow:false,
    allShowMaterialMarkerData:{
        pointList:[],
        lineList:{    //素材-线
            //线
            line:{
                'type': 'FeatureCollection',
                'features': []
            },
            //线名
            lineName:{
                'type': 'FeatureCollection',
                'features': []
            },
            //线拐点
            linePoint:{
                'type': 'FeatureCollection',
                'features': []
            },

        },
        polygonList:{
            //多边形
            polygon:{
                'type': 'FeatureCollection',
                'features': []
            },
            //多边形名
            polygonName:{
                'type': 'FeatureCollection',
                'features': []
            },
            //多边形拐点
            polygonPoint:{
                'type': 'FeatureCollection',
                'features': []
            },

        },
        imageList:[],
    },


    //添加素材图片
    sceneMaterialImageAdding:false,
    sceneMaterialImageAddingDataList:[],




    //录制操作
    scenePointEditing:false,   //false不是正在编辑添加录制点位（没有边框，球下方按钮为 添加录制点位），true为正在编辑录制点，视野点相关内容使用temp临时变量
    sceneOperationState_addViewPointGuideState:"",   //录制操作中添加视野点提示类型：firstViewPoint添加初始视野点，
                                                //viewPoint1添加视野点中1，viewPoint2添加视野点中2，newViewPoint必须添加新视野点，
                                                //viewPointFinish添加视野点完成
    sceneOperationState_addViewPointRecommendedAnimationShow:false,    //添加视野点引导 推荐动画显隐
    sceneOperationLayerState:"",   //录制操作引导蒙层状态：mapOperation地图亮，addViewPointFinish仅添加视野点完成按钮亮

    //录制样例数据
    sceneExampleList:[],

    //录制图标
    sceneViewMarkerShow:false,
    sceneViewMarkerSelectingShow:false,
    sceneMaterialShow:false,


    //录制 当前播放到的录制点
    sceneCurrPlayItem:"",


    //统一提示toast
    snackbarShow:false,
    snackbarType:"success",
    snackbarText:'',

    filterField: '全部',
    orderType: '降序',
    orderField: '更新时间',

    //项目打开来源：windows来自客户端
    openSource:"",


  },
  mutations: {
    setNickName(state, account) {
      state.nickName = account
    },
    setAvatar(state,avatar) {
      state.avatar = avatar
    },
    setUserid(state,userid) {
      state.userId = userid
    },
    setEmail(state, email) {
      state.email = email
    },
    setIntroduce(state,introduce) {
      state.introduce = introduce
    },
    setAppBound(state,appBound) {
      state.appBound = appBound
    },
    setThreeDIndex(state,threeDIndex) {
      state.threeDIndex = threeDIndex
    },
    setShowFeedBackDialog(state,showFeedBackDialog) {
      state.showFeedBackDialog = showFeedBackDialog
    },
    setShowDownloadProductsDialog(state, showDownloadProductsDialog) {
      state.showDownloadProductsDialog = showDownloadProductsDialog
    },
  },
  actions: {
  },
  modules: {
  }
})
